import isEqual from 'react-fast-compare';
import Ranking from './Ranking';
import React from 'react';
import styles from './Rankings.module.scss';

type Props = {
    mobile: boolean;
    modal?: boolean;
    percentiles: any;
};

const CUTOFF = 80;

const acc = {
    name: 'ranking.accName',
    popoverHeader: 'ranking.accPopoverHeader',
    popoverText: 'ranking.accPopoverText',
};

const resp = {
    name: 'ranking.respName',
    popoverHeader: 'ranking.respPopoverHeader',
    popoverText: 'ranking.respPopoverText',
};

const pay = {
    name: 'ranking.payName',
    popoverHeader: 'ranking.payPopoverHeader',
    popoverText: 'ranking.payPopoverText',
};

const ship = {
    name: 'ranking.shipName',
    popoverHeader: 'ranking.shipPopoverHeader',
    popoverText: 'ranking.shipPopoverText',
};

const Rankings = (props: Props) => {
    const { mobile, modal, percentiles } = props;
    const { accuracy, payment, responsiveness, shipping } = percentiles;
    const showPayment = payment >= CUTOFF;
    const showAccuracy = accuracy >= CUTOFF;
    const showShipping = shipping >= CUTOFF;
    const showResponsiveness = responsiveness >= CUTOFF;

    let rankingsStyle = mobile ? styles.rankingsMobile : modal ? styles.rankingsModal : styles.rankings;

    return (
        <div className={styles.container}>
            <div className={rankingsStyle}>
                {showAccuracy && (
                    <Ranking
                        modal={modal}
                        name={acc.name}
                        popoverHeader={acc.popoverHeader}
                        popoverText={acc.popoverText}
                    />
                )}
                {showResponsiveness && (
                    <Ranking
                        modal={modal}
                        name={resp.name}
                        popoverHeader={resp.popoverHeader}
                        popoverText={resp.popoverText}
                    />
                )}
                {showPayment && (
                    <Ranking
                        modal={modal}
                        name={pay.name}
                        popoverHeader={pay.popoverHeader}
                        popoverText={pay.popoverText}
                    />
                )}
                {showShipping && (
                    <Ranking
                        modal={modal}
                        name={ship.name}
                        popoverHeader={ship.popoverHeader}
                        popoverText={ship.popoverText}
                    />
                )}
            </div>
        </div>
    );
};

export default React.memo<Props>(Rankings, isEqual);
